const TableBody = ({ children }) => {
  return <tbody className="relative w-full divide-y divide-gray-200">{children}</tbody>;
};

export default TableBody;
